"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hsv2hex = hsv2hex;
var hsv2rgb_1 = require("./hsv2rgb");
var rgb2hex_1 = require("./rgb2hex");
/** Converts HSV components to a hex color string (without # prefix). */
function hsv2hex(h, s, v) {
    var _a = (0, hsv2rgb_1.hsv2rgb)(h, s, v), r = _a.r, g = _a.g, b = _a.b;
    return (0, rgb2hex_1.rgb2hex)(r, g, b);
}
//# sourceMappingURL=hsv2hex.js.map